import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";

import { Terms } from "../../interfaces/privacy-state.interface";

export const loadAcceptTerms = createAction(
  "[Privacy-Terms] Load Accept Terms",
  props<{ version: string }>(),
);

export const acceptTermsSuccess = createAction(
  "[Privacy-Terms] Load Accept Terms Success",
  props<{ response: {} }>(),
);

export const acceptTermsFailure = createAction(
  "[Privacy-Terms] Load Accept Terms Failure",
  props<{ error: HttpErrorResponse }>(),
);

export const loadTerms = createAction("[Privacy-Terms] Load Terms Call");

export const loadTermsSuccess = createAction(
  "[Privacy-Terms] Load Terms Success",
  props<{ terms: Terms[] }>(),
);

export const loadTermsFailure = createAction(
  "[Privacy-Terms] Load Terms Failure",
  props<{ error: HttpErrorResponse }>(),
);
